<script setup lang="ts">
const { align = 'right', open } = defineProps<{
  align?: 'left' | 'right'
  open: boolean
}>()

defineSlots<{
  default(): string
}>()
</script>

<template>
  <div
    class="absolute top-full z-20 mt-0.5 inline-flex flex-col items-start justify-center gap-1.5 truncate rounded-lg border border-black-50 bg-white py-2.5 shadow-lg"
    :class="[open ? '' : 'hidden', align === 'right' ? 'right-0' : 'left-0']"
  >
    <slot></slot>
  </div>
</template>
